import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "create-exam-view exam-view-container" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "flex items-center mb-4" }
const _hoisted_4 = { class: "grid grid-cols-1 xl:grid-cols-3 gap-6" }
const _hoisted_5 = { class: "xl:col-span-2 space-y-6" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = { class: "w-8 h-8 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center mr-3" }
const _hoisted_10 = { class: "card-body space-y-4" }
const _hoisted_11 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-header" }
const _hoisted_14 = { class: "flex items-center justify-between" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "w-8 h-8 rounded-lg bg-green-100 dark:bg-green-900/30 flex items-center justify-center mr-3" }
const _hoisted_17 = { class: "text-lg font-semibold text-gray-900 dark:text-white" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_20 = {
  key: 1,
  class: "space-y-4"
}
const _hoisted_21 = { class: "flex items-start justify-between mb-3" }
const _hoisted_22 = { class: "flex items-center gap-2" }
const _hoisted_23 = { class: "text-sm font-medium text-gray-900 dark:text-white" }
const _hoisted_24 = {
  key: 0,
  class: "text-xs px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded-full"
}
const _hoisted_25 = {
  key: 1,
  class: "text-xs px-2 py-1 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-full"
}
const _hoisted_26 = { class: "flex items-center gap-2" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "mb-3 p-2 bg-red-100 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded text-sm"
}
const _hoisted_29 = { class: "text-red-600 dark:text-red-400 text-xs space-y-1" }
const _hoisted_30 = { class: "space-y-3" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["onUpdate:modelValue", "onChange"]
const _hoisted_33 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_34 = { class: "text-sm font-medium text-gray-600 dark:text-gray-400 w-6" }
const _hoisted_35 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "bg-gray-50 dark:bg-gray-800 rounded-lg p-3" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["value"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { key: 2 }
const _hoisted_45 = {
  key: 0,
  class: "text-center mt-4"
}
const _hoisted_46 = { class: "space-y-6" }
const _hoisted_47 = { class: "sticky-sidebar" }
const _hoisted_48 = { class: "card" }
const _hoisted_49 = { class: "card-body space-y-4" }
const _hoisted_50 = { class: "flex items-center justify-between" }
const _hoisted_51 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_52 = { class: "flex items-center justify-between" }
const _hoisted_53 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_54 = { class: "flex items-center justify-between" }
const _hoisted_55 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_56 = { class: "flex items-center justify-between" }
const _hoisted_57 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_58 = { class: "flex items-center justify-between" }
const _hoisted_59 = { class: "font-medium text-gray-900 dark:text-white" }
const _hoisted_60 = { class: "pt-3 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_61 = { class: "flex items-center justify-between mb-2" }
const _hoisted_62 = {
  key: 0,
  class: "text-xs px-2 py-1 bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded-full"
}
const _hoisted_63 = {
  key: 1,
  class: "text-xs px-2 py-1 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-full"
}
const _hoisted_64 = {
  key: 0,
  class: "text-xs text-red-600 dark:text-red-400 space-y-1"
}
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = { key: 2 }
const _hoisted_68 = { key: 3 }
const _hoisted_69 = { class: "mt-2 card" }
const _hoisted_70 = { class: "card-body space-y-3" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = ["disabled"]

import { ref, computed } from 'vue'
import { useTitle } from '@/composables/ui/useTitle'
import { useToastService } from '@/services/toast'
import { examService } from '@/services/examService'
import type { Question, CreateExamPayload } from '@/services/examService'
import IncompleteQuestionsModal from '@/components/modals/IncompleteQuestionsModal.vue'
import KeywordInput from '@/components/forms/KeywordInput.vue'
import {
  Plus,
  FileText,
  X,
  ArrowLeft,
  HelpCircle,
  Save,
  Trash2,
  ArrowUp
} from 'lucide-vue-next'

// Props and Emits

export default /*@__PURE__*/_defineComponent({
  __name: 'CreateExamView',
  emits: ["back", "examCreated"],
  setup(__props, { emit: __emit }) {

const emit = __emit

// Page title
const appTitle = computed(() => process.env.VUE_APP_TITLE || 'Douglas Private Care Services')
useTitle(`Create New Exam - ${appTitle.value}`)

// Services
const toastService = useToastService()

// Helper function to maintain backward compatibility
const showToast = (message: string, type: 'success' | 'error' | 'info' = 'info') => {
  if (type === 'success') {
    toastService.success(message)
  } else if (type === 'error') {
    toastService.error(message)
  } else {
    toastService.success(message) // Use success for info since the service may not have info
  }
}

// State
const loading = ref(false)
const showIncompleteModal = ref(false)
const pendingSaveType = ref<'exam' | 'draft'>('exam')

// New exam form with proper typing
const newExam = ref<CreateExamPayload>({
  exam_name: '',
  exam_content: {
    questions: [] as Question[]
  },
  answer_key: {} as Record<string, any>,
  passing_rate: 70,
  time_limit: null,
  total_attempts: 3,
  exam_status: 1
})

// Question ID counter
let questionIdCounter = 1

// Helper method for essay keywords
const getEssayKeywords = (questionId: number): string[] => {
  if (!newExam.value.answer_key[questionId]) {
    return []
  }
  return newExam.value.answer_key[questionId] as string[]
}

const updateEssayKeywords = (questionId: number, keywords: string[]) => {
  newExam.value.answer_key[questionId] = keywords
}

// Input validation functions
const preventDecimalInput = (event: KeyboardEvent) => {
  // Prevent decimal point and minus sign
  if (event.key === '.' || event.key === ',' || event.key === '-' || event.key === 'e' || event.key === 'E') {
    event.preventDefault()
  }
}

const handleTimeLimitInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  let value = target.value
  
  // If empty, set to null (unlimited)
  if (value === '' || value === null) {
    newExam.value.time_limit = null
    return
  }
  
  // Remove any non-digit characters
  value = value.replace(/[^\d]/g, '')
  
  // Convert to number
  let numValue = parseInt(value, 10)
  
  // If NaN, set to null
  if (isNaN(numValue)) {
    newExam.value.time_limit = null
    target.value = ''
    return
  }
  
  // Enforce min and max
  if (numValue < 1) {
    numValue = 1
  } else if (numValue > 1440) {
    numValue = 1440
  }
  
  newExam.value.time_limit = numValue
  target.value = numValue.toString()
}

const handleTotalAttemptsInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  let value = target.value
  
  // If empty, set to null (unlimited)
  if (value === '' || value === null) {
    newExam.value.total_attempts = null
    return
  }
  
  // Remove any non-digit characters
  value = value.replace(/[^\d]/g, '')
  
  // Convert to number
  let numValue = parseInt(value, 10)
  
  // If NaN, set to null
  if (isNaN(numValue)) {
    newExam.value.total_attempts = null
    target.value = ''
    return
  }
  
  // Enforce min and max
  if (numValue < 1) {
    numValue = 1
  } else if (numValue > 10) {
    numValue = 10
  }
  
  newExam.value.total_attempts = numValue
  target.value = numValue.toString()
}

// Computed properties
const canSaveExam = computed(() => {
  // Check if exam name is filled
  if (!newExam.value.exam_name || !newExam.value.exam_name.trim()) {
    return false
  }

  // Check if passing rate is set (should be between 1 and 100)
  if (!newExam.value.passing_rate || newExam.value.passing_rate <= 0 || newExam.value.passing_rate > 100) {
    return false
  }

  // Check if there are any questions
  if (newExam.value.exam_content.questions.length === 0) {
    return false
  }

  // Check if at least one question is properly filled
  const hasValidQuestion = newExam.value.exam_content.questions.some((question: Question) => {
    // Question text must be filled
    if (!question.question.trim()) {
      return false
    }

    // Check based on question type
    if (question.type === 'multiple_choice') {
      // Must have at least 2 options with text, and a correct answer selected
      const validOptions = question.options?.filter(option => option.text && option.text.trim()) || []
      const hasCorrectAnswer = newExam.value.answer_key[question.id]
      return validOptions.length >= 2 && hasCorrectAnswer
    } else if (question.type === 'true_false') {
      // Must have a correct answer selected
      return newExam.value.answer_key[question.id] !== undefined && newExam.value.answer_key[question.id] !== ''
    } else if (question.type === 'essay') {
      // Must have at least one keyword
      const keywords = newExam.value.answer_key[question.id] || []
      return keywords.length > 0
    }

    return false
  })

  return hasValidQuestion
})

// Helper computed to track which questions are incomplete
const incompleteQuestions = computed(() => {
  return newExam.value.exam_content.questions.map((question: Question, index: number) => {
    const issues: string[] = []
    
    // Check if question text is filled
    if (!question.question.trim()) {
      issues.push('Question text is required')
    }
    
    // Check based on question type
    if (question.type === 'multiple_choice') {
      const validOptions = question.options?.filter(option => option.text && option.text.trim()) || []
      
      // Check if options are filled in order (no gaps)
      if (question.options) {
        for (let i = 0; i < question.options.length; i++) {
          const currentOption = question.options[i]
          const isEmpty = !currentOption.text || !currentOption.text.trim()
          
          if (isEmpty) {
            // Check if there are filled options after this empty one
            const hasFilledAfter = question.options.slice(i + 1).some(opt => opt.text && opt.text.trim())
            if (hasFilledAfter) {
              issues.push(`Option ${String.fromCharCode(65 + i)} must be filled before later options`)
            }
          }
        }
      }
      
      if (validOptions.length < 2) {
        issues.push('At least 2 options must be filled')
      }
      if (!newExam.value.answer_key[question.id]) {
        issues.push('Correct answer must be selected')
      }
    } else if (question.type === 'true_false') {
      if (newExam.value.answer_key[question.id] === undefined || newExam.value.answer_key[question.id] === '') {
        issues.push('Correct answer must be selected')
      }
    } else if (question.type === 'essay') {
      const keywords = newExam.value.answer_key[question.id] || []
      if (keywords.length === 0) {
        issues.push('At least one keyword is required')
      }
    }
    
    return {
      index,
      isComplete: issues.length === 0,
      issues
    }
  })
})

// Helper function to check if a question is complete
const isQuestionComplete = (question: Question): boolean => {
  // Check if question text is filled
  if (!question.question.trim()) {
    return false
  }
  
  // Check based on question type
  if (question.type === 'multiple_choice') {
    const validOptions = question.options?.filter(option => option.text && option.text.trim()) || []
    
    // Check if options are filled in order (no gaps)
    if (question.options) {
      for (let i = 0; i < question.options.length; i++) {
        const currentOption = question.options[i]
        const isEmpty = !currentOption.text || !currentOption.text.trim()
        
        if (isEmpty) {
          // Check if there are filled options after this empty one
          const hasFilledAfter = question.options.slice(i + 1).some(opt => opt.text && opt.text.trim())
          if (hasFilledAfter) {
            return false // Has gaps in options
          }
        }
      }
    }
    
    if (validOptions.length < 2) {
      return false
    }
    if (!newExam.value.answer_key[question.id]) {
      return false
    }
  } else if (question.type === 'true_false') {
    if (newExam.value.answer_key[question.id] === undefined || newExam.value.answer_key[question.id] === '') {
      return false
    }
  } else if (question.type === 'essay') {
    const keywords = newExam.value.answer_key[question.id] || []
    if (keywords.length === 0) {
      return false
    }
  }
  
  return true
}

// Scroll helper to go back to top of this view
const scrollToTop = () => {
  const el = document.querySelector('.create-exam-view') as HTMLElement | null
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' })
  } else {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

// Computed property for modal data - reuses incompleteQuestions logic
const modalQuestionsData = computed(() => {
  return incompleteQuestions.value.map((questionData) => ({
    index: questionData.index,
    question: newExam.value.exam_content.questions[questionData.index]?.question || '',
    isComplete: questionData.isComplete,
    issues: questionData.issues
  }))
})

// Lifecycle
const addQuestion = () => {
  const newQuestion: Question = {
    id: questionIdCounter++,
    question: '',
    type: 'multiple_choice',
    options: [
      { id: 'a', text: '' },
      { id: 'b', text: '' },
      { id: 'c', text: '' },
      { id: 'd', text: '' }
    ]
  }
  newExam.value.exam_content.questions.push(newQuestion)
}

const removeQuestion = (index: number) => {
  const question = newExam.value.exam_content.questions[index]
  delete newExam.value.answer_key[question.id]
  newExam.value.exam_content.questions.splice(index, 1)
}

const updateQuestionType = (question: Question) => {
  // Reset answer key when question type changes
  delete (newExam.value.answer_key as any)[question.id]
  
  // Initialize answer key based on type
  if (question.type === 'essay') {
    newExam.value.answer_key[question.id] = []
  }
  
  // Update options based on type
  if (question.type === 'multiple_choice') {
    question.options = [
      { id: 'a', text: '' },
      { id: 'b', text: '' },
      { id: 'c', text: '' },
      { id: 'd', text: '' }
    ]
  } else {
    delete (question as any).options
  }
}

const addOption = (question: Question) => {
  if (question.options) {
    // Check if all current options are filled before adding a new one
    const hasEmptyOptions = question.options.some(option => !option.text || !option.text.trim())
    
    if (hasEmptyOptions) {
      showToast('Please fill all current options before adding a new one', 'info')
      return
    }
    
    const nextLetter = String.fromCharCode(97 + question.options.length) // a, b, c, d, e, f
    question.options.push({
      id: nextLetter,
      text: ''
    })
  }
}

// Helper function to get validation classes for options
const getOptionValidationClass = (question: Question, optIndex: number) => {
  if (!question.options) return 'border-gray-300 dark:border-gray-600'
  
  const option = question.options[optIndex]
  const isEmpty = !option.text || !option.text.trim()
  
  if (isEmpty) {
    // Check if there are filled options after this empty one
    const hasFilledAfter = question.options.slice(optIndex + 1).some(opt => opt.text && opt.text.trim())
    if (hasFilledAfter) {
      return 'border-red-500 dark:border-red-500 bg-red-50 dark:bg-red-900/10'
    }
    return 'border-gray-300 dark:border-gray-600'
  }
  
  return 'border-green-500 dark:border-green-500 bg-green-50 dark:bg-green-900/10'
}

const removeOption = (question: Question, index: number) => {
  if (question.options) {
    question.options.splice(index, 1)
    // Update option IDs to maintain a, b, c, d sequence
    question.options.forEach((option: { id: string; text: string }, idx: number) => {
      option.id = String.fromCharCode(97 + idx)
    })
  }
}

// Helper function to clean up exam data before saving
const cleanExamData = (examData: CreateExamPayload): CreateExamPayload => {
  const cleanedData = JSON.parse(JSON.stringify(examData)) // Deep clone
  
  // Filter out incomplete questions first, then clean up the remaining complete questions
  cleanedData.exam_content.questions = cleanedData.exam_content.questions
    .filter((question: Question) => isQuestionComplete(question))
    .map((question: Question) => {
      const cleanedQuestion = { ...question }
      
      // For multiple choice questions, filter out empty options
      if (question.type === 'multiple_choice' && question.options) {
        cleanedQuestion.options = question.options.filter(option => 
          option.text && option.text.trim() !== ''
        )
        
        // Re-assign option IDs to maintain sequence (a, b, c, etc.)
        cleanedQuestion.options.forEach((option: { id: string; text: string }, idx: number) => {
          option.id = String.fromCharCode(97 + idx) // a, b, c, d, e, f
        })
      }
      
      return cleanedQuestion
    })
  
  return cleanedData
}

const saveExam = async () => {
  // Check if exam name is filled
  if (!newExam.value.exam_name || !newExam.value.exam_name.trim()) {
    showToast('Please enter an exam name before saving', 'error')
    return
  }

  // Check if passing rate is set
  if (!newExam.value.passing_rate || newExam.value.passing_rate <= 0 || newExam.value.passing_rate > 100) {
    showToast('Please set a valid passing rate (1-100%)', 'error')
    return
  }

  // Check if there are any questions
  if (newExam.value.exam_content.questions.length === 0) {
    showToast('Please add at least one question before saving', 'error')
    return
  }

  // Check if there are any complete questions
  const hasCompleteQuestion = incompleteQuestions.value.some(q => q.isComplete)
  if (!hasCompleteQuestion) {
    showToast('Please complete at least one question before saving', 'error')
    return
  }

  // Check if there are incomplete questions
  const hasIncompleteQuestions = incompleteQuestions.value.some(q => !q.isComplete)
  if (hasIncompleteQuestions) {
    pendingSaveType.value = 'exam'
    showIncompleteModal.value = true
    return
  }

  // If all questions are complete, proceed directly
  await performSave('exam')
}

const saveDraftExam = async () => {
  // Check if exam name is filled
  if (!newExam.value.exam_name || !newExam.value.exam_name.trim()) {
    showToast('Please enter an exam name before saving', 'error')
    return
  }

  // Check if passing rate is set
  if (!newExam.value.passing_rate || newExam.value.passing_rate <= 0 || newExam.value.passing_rate > 100) {
    showToast('Please set a valid passing rate (1-100%)', 'error')
    return
  }

  // Check if there are any questions
  if (newExam.value.exam_content.questions.length === 0) {
    showToast('Please add at least one question before saving', 'error')
    return
  }

  // Check if there are any complete questions
  const hasCompleteQuestion = incompleteQuestions.value.some(q => q.isComplete)
  if (!hasCompleteQuestion) {
    showToast('Please complete at least one question before saving', 'error')
    return
  }

  // Check if there are incomplete questions
  const hasIncompleteQuestions = incompleteQuestions.value.some(q => !q.isComplete)
  if (hasIncompleteQuestions) {
    pendingSaveType.value = 'draft'
    showIncompleteModal.value = true
    return
  }

  // If all questions are complete, proceed directly
  await performSave('draft')
}

const proceedWithSave = async () => {
  showIncompleteModal.value = false
  await performSave(pendingSaveType.value)
}

const performSave = async (type: 'exam' | 'draft') => {
  try {
    loading.value = true
    const cleanedExamData = cleanExamData(newExam.value)
    cleanedExamData.exam_status = type === 'exam' ? 1 : 0
    await examService.createExam(cleanedExamData)
    showToast(`Exam ${type === 'exam' ? 'created' : 'saved as draft'} successfully!`, 'success')
    resetForm()
    emit('examCreated')
    emit('back')
  } catch (err: any) {
    console.error(`Error ${type === 'exam' ? 'creating' : 'saving'} exam:`, err)
    showToast(err.response?.data?.message || `Failed to ${type === 'exam' ? 'create' : 'save'} exam`, 'error')
  } finally {
    loading.value = false
  }
}

const resetForm = () => {
  newExam.value = {
    exam_name: '',
    exam_content: {
      questions: []
    },
    answer_key: {},
    passing_rate: 70,
    time_limit: null,
    exam_status: 1
  }
  questionIdCounter = 1
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
          class: "flex items-center text-secondary-text dark:text-secondary-dark-text hover:text-gray-900 dark:hover:text-white transition-colors mr-4"
        }, [
          _createVNode(_unref(ArrowLeft), { class: "w-5 h-5 mr-2" }),
          _cache[7] || (_cache[7] = _createTextVNode(" Back to Exams ", -1))
        ])
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-2" }, " Create New Exam ", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text" }, " Design and create new examination content with custom questions and settings. ", -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(FileText), { class: "w-5 h-5 text-blue-600 dark:text-blue-400" })
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 dark:text-white" }, " Basic Information ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-900 dark:text-white mb-2" }, [
                _createTextVNode(" Exam Name "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newExam.value.exam_name) = $event)),
                type: "text",
                class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200",
                placeholder: "Enter exam name"
              }, null, 512), [
                [_vModelText, newExam.value.exam_name]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-900 dark:text-white mb-2" }, [
                  _createTextVNode(" Passing Rate (%) "),
                  _createElementVNode("span", { class: "text-red-500" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newExam.value.passing_rate) = $event)),
                  type: "number",
                  min: "0",
                  max: "100",
                  class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200",
                  placeholder: "70"
                }, null, 512), [
                  [
                    _vModelText,
                    newExam.value.passing_rate,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-900 dark:text-white mb-2" }, " Time Limit (minutes) ", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newExam.value.time_limit) = $event)),
                  type: "number",
                  min: "1",
                  max: "1440",
                  step: "1",
                  onInput: handleTimeLimitInput,
                  onKeypress: preventDecimalInput,
                  class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200",
                  placeholder: "No time limit"
                }, null, 544), [
                  [
                    _vModelText,
                    newExam.value.time_limit,
                    void 0,
                    { number: true }
                  ]
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-xs text-secondary-text dark:text-secondary-dark-text mt-1" }, " Leave empty for no time limit (max: 1440 minutes) ", -1))
              ]),
              _createElementVNode("div", null, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-900 dark:text-white mb-2" }, " Max Attempts ", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newExam.value.total_attempts) = $event)),
                  type: "number",
                  min: "1",
                  max: "10",
                  step: "1",
                  onInput: handleTotalAttemptsInput,
                  onKeypress: preventDecimalInput,
                  class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200",
                  placeholder: "Unlimited"
                }, null, 544), [
                  [
                    _vModelText,
                    newExam.value.total_attempts,
                    void 0,
                    { number: true }
                  ]
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-xs text-secondary-text dark:text-secondary-dark-text mt-1" }, " Leave empty for unlimited (max: 10 attempts) ", -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(HelpCircle), { class: "w-5 h-5 text-green-600 dark:text-green-400" })
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_17, " Questions (" + _toDisplayString(newExam.value.exam_content.questions.length) + ") ", 1),
                  _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-xs text-secondary-text dark:text-secondary-dark-text mt-1" }, " Add questions for this exam ", -1))
                ])
              ]),
              _createElementVNode("button", {
                onClick: addQuestion,
                class: "btn btn-sm btn-primary flex items-center gap-2"
              }, [
                _createVNode(_unref(Plus), { class: "w-4 h-4" }),
                _cache[18] || (_cache[18] = _createTextVNode(" Add Question ", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            (newExam.value.exam_content.questions.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_unref(HelpCircle), { class: "w-12 h-12 text-gray-400 mx-auto mb-4" }),
                  _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 dark:text-white mb-2" }, " No questions added yet ", -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-secondary-text dark:text-secondary-dark-text mb-4" }, " Start building your exam by adding questions. ", -1)),
                  _createElementVNode("button", {
                    onClick: addQuestion,
                    class: "btn btn-primary"
                  }, " Add Your First Question ")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newExam.value.exam_content.questions, (question, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: question.id,
                      class: _normalizeClass([
                  'border rounded-lg p-4',
                  incompleteQuestions.value[index]?.isComplete 
                    ? 'border-green-200 dark:border-green-700 bg-green-50 dark:bg-green-900/10' 
                    : 'border-red-200 dark:border-red-700 bg-red-50 dark:bg-red-900/10'
                ])
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("h4", _hoisted_23, " Question " + _toDisplayString(index + 1), 1),
                          (incompleteQuestions.value[index]?.isComplete)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Complete "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_25, " Incomplete "))
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (removeQuestion(index)),
                            class: "text-red-500 hover:text-red-700 transition-colors",
                            title: "Remove question"
                          }, [
                            _createVNode(_unref(Trash2), { class: "w-4 h-4" })
                          ], 8, _hoisted_27)
                        ])
                      ]),
                      (!incompleteQuestions.value[index]?.isComplete)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-red-700 dark:text-red-300 font-medium mb-1" }, "Required Fields:", -1)),
                            _createElementVNode("ul", _hoisted_29, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(incompleteQuestions.value[index]?.issues, (issue) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: issue,
                                  class: "flex items-center gap-1"
                                }, [
                                  _cache[21] || (_cache[21] = _createElementVNode("span", { class: "w-1 h-1 bg-red-500 rounded-full" }, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(issue), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", null, [
                          _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-900 dark:text-white mb-1" }, " Question Text * ", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            "onUpdate:modelValue": ($event: any) => ((question.question) = $event),
                            rows: "2",
                            class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200",
                            placeholder: "Enter your question here..."
                          }, null, 8, _hoisted_31), [
                            [_vModelText, question.question]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-900 dark:text-white mb-1" }, " Question Type * ", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": ($event: any) => ((question.type) = $event),
                            onChange: ($event: any) => (updateQuestionType(question)),
                            class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200"
                          }, [...(_cache[24] || (_cache[24] = [
                            _createElementVNode("option", { value: "multiple_choice" }, "Multiple Choice", -1),
                            _createElementVNode("option", { value: "true_false" }, "True/False", -1),
                            _createElementVNode("option", { value: "essay" }, "Essay", -1)
                          ]))], 40, _hoisted_32), [
                            [_vModelSelect, question.type]
                          ])
                        ]),
                        (question.type === 'multiple_choice')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-900 dark:text-white mb-1" }, " Options * ", -1)),
                              _cache[28] || (_cache[28] = _createElementVNode("p", { class: "text-xs text-gray-500 dark:text-gray-400 mb-2" }, " Fill options in order (A, then B, then C, etc.). Empty options with filled options after them will show validation errors. ", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.options, (option, optIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: optIndex,
                                  class: "flex items-center gap-2"
                                }, [
                                  _createElementVNode("span", _hoisted_34, _toDisplayString(String.fromCharCode(65 + optIndex)) + ". ", 1),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((option.text) = $event),
                                    type: "text",
                                    class: _normalizeClass([
                          'flex-1 px-3 py-2 border rounded-lg transition duration-200',
                          'bg-white dark:bg-gray-800 text-gray-900 dark:text-white',
                          'focus:ring-2 focus:ring-primary focus:border-primary',
                          getOptionValidationClass(question, optIndex)
                        ]),
                                    placeholder: `Option ${String.fromCharCode(65 + optIndex)}`
                                  }, null, 10, _hoisted_35), [
                                    [_vModelText, option.text]
                                  ]),
                                  (question.options && question.options.length > 2)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: ($event: any) => (removeOption(question, optIndex)),
                                        class: "text-red-500 hover:text-red-700 transition-colors"
                                      }, [
                                        _createVNode(_unref(X), { class: "w-4 h-4" })
                                      ], 8, _hoisted_36))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128)),
                              (question.options && question.options.length < 6)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (addOption(question)),
                                    class: "text-sm text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 flex items-center gap-1"
                                  }, [
                                    _createVNode(_unref(Plus), { class: "w-3 h-3" }),
                                    _cache[26] || (_cache[26] = _createTextVNode(" Add Option ", -1))
                                  ], 8, _hoisted_37))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_38, [
                          _cache[31] || (_cache[31] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-900 dark:text-white mb-2" }, " Correct Answer * ", -1)),
                          (question.type === 'multiple_choice')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": ($event: any) => ((newExam.value.answer_key[question.id]) = $event),
                                  class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200"
                                }, [
                                  _cache[29] || (_cache[29] = _createElementVNode("option", { value: "" }, "Select correct option", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.options?.filter(opt => opt.text && opt.text.trim()), (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: option.id,
                                      value: option.id
                                    }, _toDisplayString(option.id.toUpperCase()) + ". " + _toDisplayString(option.text), 9, _hoisted_41))
                                  }), 128))
                                ], 8, _hoisted_40), [
                                  [_vModelSelect, newExam.value.answer_key[question.id]]
                                ])
                              ]))
                            : (question.type === 'true_false')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": ($event: any) => ((newExam.value.answer_key[question.id]) = $event),
                                    class: "w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary focus:border-primary transition duration-200"
                                  }, [...(_cache[30] || (_cache[30] = [
                                    _createElementVNode("option", { value: "" }, "Select answer", -1),
                                    _createElementVNode("option", { value: "true" }, "True", -1),
                                    _createElementVNode("option", { value: "false" }, "False", -1)
                                  ]))], 8, _hoisted_43), [
                                    [_vModelSelect, newExam.value.answer_key[question.id]]
                                  ])
                                ]))
                              : (question.type === 'essay')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    _createVNode(KeywordInput, {
                                      "model-value": getEssayKeywords(question.id),
                                      "onUpdate:modelValue": ($event: any) => (updateEssayKeywords(question.id, $event)),
                                      placeholder: "Enter keywords or key points for this essay question..."
                                    }, null, 8, ["model-value", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true)
                        ])
                      ])
                    ], 2))
                  }), 128)),
                  (newExam.value.exam_content.questions.length >= 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("button", {
                          onClick: scrollToTop,
                          type: "button",
                          class: "inline-flex items-center text-sm text-gray-900 dark:text-white hover:underline"
                        }, [
                          _createVNode(_unref(ArrowUp), { class: "w-4 h-4 mr-2" }),
                          _cache[32] || (_cache[32] = _createTextVNode(" Back to top ", -1))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900 dark:text-white" }, " Exam Preview ")
            ], -1)),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "Questions", -1)),
                _createElementVNode("span", _hoisted_51, _toDisplayString(newExam.value.exam_content.questions.length), 1)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "Complete Questions", -1)),
                _createElementVNode("span", _hoisted_53, _toDisplayString(incompleteQuestions.value.filter(q => q.isComplete).length) + " / " + _toDisplayString(incompleteQuestions.value.length), 1)
              ]),
              _createElementVNode("div", _hoisted_54, [
                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "Passing Rate", -1)),
                _createElementVNode("span", _hoisted_55, _toDisplayString(newExam.value.passing_rate || 0) + "% ", 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "Time Limit", -1)),
                _createElementVNode("span", _hoisted_57, _toDisplayString(newExam.value.time_limit ? `${newExam.value.time_limit} min` : 'No limit'), 1)
              ]),
              _createElementVNode("div", _hoisted_58, [
                _cache[37] || (_cache[37] = _createElementVNode("span", { class: "text-sm text-secondary-text dark:text-secondary-dark-text" }, "Max Attempts", -1)),
                _createElementVNode("span", _hoisted_59, _toDisplayString(newExam.value.total_attempts ? `${newExam.value.total_attempts}` : 'Unlimited'), 1)
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-sm font-medium text-gray-900 dark:text-white" }, "Status", -1)),
                  (canSaveExam.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_62, " Ready to Save "))
                    : (_openBlock(), _createElementBlock("span", _hoisted_63, " Not Ready "))
                ]),
                (!canSaveExam.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      (!newExam.value.exam_name || !newExam.value.exam_name.trim())
                        ? (_openBlock(), _createElementBlock("p", _hoisted_65, "• Enter exam name"))
                        : _createCommentVNode("", true),
                      (!newExam.value.passing_rate || newExam.value.passing_rate <= 0 || newExam.value.passing_rate > 100)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_66, "• Set valid passing rate (1-100%)"))
                        : _createCommentVNode("", true),
                      (newExam.value.exam_content.questions.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_67, "• Add at least one question"))
                        : (!incompleteQuestions.value.some(q => q.isComplete))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_68, "• Complete at least one question"))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("button", {
                onClick: saveExam,
                disabled: !canSaveExam.value || loading.value,
                class: "w-full btn btn-primary"
              }, [
                _createVNode(_unref(Save), { class: "w-4 h-4 mr-2" }),
                _cache[40] || (_cache[40] = _createTextVNode(" Save Exam ", -1))
              ], 8, _hoisted_71),
              _createElementVNode("button", {
                onClick: saveDraftExam,
                disabled: !canSaveExam.value || loading.value,
                class: "w-full btn btn-secondary"
              }, [
                _createVNode(_unref(FileText), { class: "w-4 h-4 mr-2" }),
                _cache[41] || (_cache[41] = _createTextVNode(" Save as Draft ", -1))
              ], 8, _hoisted_72),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('back'))),
                class: "w-full btn btn-outline"
              }, " Cancel ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode(IncompleteQuestionsModal, {
      "is-visible": showIncompleteModal.value,
      "incomplete-questions": modalQuestionsData.value,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (showIncompleteModal.value = false)),
      onConfirm: proceedWithSave
    }, null, 8, ["is-visible", "incomplete-questions"])
  ]))
}
}

})